import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "40x40/images_empty"
  }, React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1458 0.744525C18.3227 0.488314 16.6372 1.75848 16.381 3.58151L15.7605 7.99629L19.2004 7.47133L19.6818 4.04542L34.5359 6.13302L32.4483 20.987L27.9564 20.3557L28.8994 27.2205L31.5205 27.5888C33.3435 27.845 35.029 26.5749 35.2853 24.7518L37.8368 6.59692C38.093 4.77389 36.8228 3.08833 34.9998 2.83212L20.1458 0.744525Z",
    fill: "currentColor"
  }), React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16301 16.5973C1.9068 14.7742 3.17695 13.0887 4.99999 12.8325L19.854 10.7449C21.677 10.4887 23.3626 11.7588 23.6188 13.5819L26.1703 31.7368C26.4265 33.5598 25.1564 35.2454 23.3333 35.5016L8.47932 37.5892C6.65628 37.8454 4.97072 36.5752 4.71451 34.7522L2.16301 16.5973ZM9.2288 18.9704C9.35691 19.8819 8.72183 20.7246 7.81031 20.8528C6.89879 20.9809 6.05601 20.3458 5.92791 19.4343C5.7998 18.5227 6.43488 17.68 7.3464 17.5519C8.25792 17.4238 9.1007 18.0588 9.2288 18.9704ZM22.6373 30.5495L21.2456 20.6469L15.721 28.4923L12.5185 25.9131L7.78337 32.6375L18.9238 31.0718L18.9234 31.0715L22.6373 30.5495Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { ImagesEmpty40 } from '@cian/ui-kit/icons';`, <br />
 * где 40 - это размер иконки в пикселях.
 */

export var ImagesEmpty40 = createIcon(IconComponent);